module.exports = __webpack_public_path__ + "img/ic-taxi.c5b0e8f8.svg";